import { Component, ComponentFactoryResolver, OnInit, ViewChild } from '@angular/core';
import { BannerService } from '@services/banner/banner.service';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { Models } from '@ibexfusion/models';
import { ActivatedRoute, Router } from '@angular/router';
import { DefaultFormComponent } from '../../../components/default-form/default-form.component';
import { FormComponent } from '../../../components/default-form/form.component';
import { FormDirective } from '../../../directives/form/form.directive';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EnvironmentService } from '@services/environment/environment.service';
import { DriverRouteService } from '@services/driver-route/driver-route.service';
import { SelectContactDialogComponent } from '../../dynamic-content/dynamic-content-edit/components/contact/select-dialog/select-contact-dialog.component';
import { EditContactDialogComponent } from '../../dynamic-content/dynamic-content-edit/components/contact/edit-dialog/edit-contact-dialog.component';
import { StepDialogComponent } from '../../../dialogs/step-dialog/step-dialog.component';
import { DialogService } from '@services/dialog/dialog.service';

@Component({
    selector: 'app-driver-edit',
    templateUrl: 'driver-edit.component.html',
    styleUrls: ['driver-edit.component.scss'],
    providers: [DriverRouteService],
    standalone: false
})

export class DriverEditComponent implements OnInit {
  @ViewChild(FormDirective, { static: true }) formHost: FormDirective;
  options = { hideFields: false };

  public title = 'Create Driver Route';

  public pageActions: PageAction[];

  driver: Models.DriverRouteModel;
  isLoading = false;
  image;
  imageUrl;

  driverId;
  public mediaAssetPath: any;

  constructor(
    public driverService: DriverRouteService, private route: ActivatedRoute, private snackbar: SnackbarService,
    private dialog: MatDialog, private environmentService: EnvironmentService, private router: Router, private dialogService: DialogService
  ) {
    this.mediaAssetPath = this.environmentService.getMediaAssetPath();
  }

  ngOnInit() {
    this.isLoading = true;
    if (this.route.snapshot.params['id']) {
      this.driverId = this.route.snapshot.params['id'];
      this.initExisting();
    } else {
      this.initNew();
    }
  }

  private initExisting() {
    this.driverService.get(this.driverId).then(driver => {
      this.driver = driver;
      this.title = 'Edit Banner';
    });
  }

  private initNew() {
    this.isLoading = false;
    this.driver = <Models.DriverRouteModel>Models.ModelFactory.createModelInstanceByName('DriverRouteModel');
  }

  async createStep() {
    let result: any;
    let dialogRef: MatDialogRef<StepDialogComponent>;
    dialogRef = this.dialog.open(StepDialogComponent, <any>{ width: '900px', height: '500px' });
    result = await dialogRef.afterClosed().toPromise();
    if (!this.driver.steps) {
      this.driver.steps = [];
    }
    if (result) {
      this.driver.steps.push(result);
    }
  }

  public dropStep(event: any) {
    if (event.previousIndex !== event.currentIndex) {
      const item = this.driver.steps.splice(event.previousIndex, 1)[0];
      this.driver.steps.splice(event.currentIndex, 0, item);
    }
  }

  async editStep(index: number) {
    let result: any;
    let dialogRef: MatDialogRef<StepDialogComponent>;
    const data = this.driver.steps[index];
    dialogRef = this.dialog.open(StepDialogComponent, <any>{ width: '900px', height: '500px', data });
    result = await dialogRef.afterClosed().toPromise();
    if (result) {
      this.driver.steps[index] = result;
    }
  }

  async removeStep(index: number) {
    const res = await this.dialogService.confirm('Diesen Schritt wirklich löschen?')
    if (res) {
      this.driver.steps.splice(index, 1);
    }
  }

  async onSave() {
    if (this.driverId) {
      await this.driverService.patch(this.driverId, this.driver);
      this.snackbar.success('Saved changes successfull');
    } else {
      const driverResult = await this.driverService.create(this.driver);
      this.snackbar.success('Saved changes successfull');
      await this.router.navigate(['driver', driverResult._id, 'edit']);
    }
  }
}
